








































































import { Vue, Component, Prop, Vuex } from "../../Infrastructure/CorBase/CoreBase";

Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		count: 0,
		isOpen: false,
		nazev: [{ id: 0, name: '', isOpen: false, parentId: -1, root: false }]
	}
})


@Component
export default class BaseTLTreeViewItem extends Vue {
	@Prop({ type: String, required: false, default: "Název" }) label?: string; //hlavní popis
	@Prop({ required: false }) item: any;
	@Prop({ type: String, required: false, default: "" }) detailRoute?: string ; //route na detail
	@Prop({ type: String, required: false, default: "" }) returnRoute?: string ; //route navratu
	@Prop({ type: Number, required: false, default: -1 }) parentId?: number; // parent id 
	@Prop({ type: String, required: false, default: "onlyView" }) typeView?: string; //typ stromu - edit, 

	@Prop({ type: Boolean, required: false, default: false }) canDelete?: boolean; //zobrazit tlačitko delete
	@Prop({ type: Boolean, required: false, default: false }) canCreate?: boolean; //zobrazit tlačitko novy
	@Prop({ type: Boolean, required: false, default: false }) canUpdate?: boolean; //zobrazit tlačitko update
	@Prop({ type: Boolean, required: false, default: false }) canRead?: boolean; //zobrazit tlačitko info
	
	created() {

		//vytvoření základního storu - pro udržení aktualního stavu
		if (store.state.nazev.filter(c => c.id == this.item.id).length == 0) {
			store.state.nazev.push({ name: this.item.name, id: this.item.id, isOpen: this.item.root ? true : false, parentId: Number(this.parentId), root: this.item.root });			
		}			
	}



	//pouze pro root - zjistim zda vsechny podobjekty jsou otevereny/zavreny
	 isOpenChildren(isOpen: boolean) {
		 let existuje = store.state.nazev.filter(c => c.isOpen == isOpen && c.root == undefined);
		 return existuje.length > 0;
	}	

	//pro jakykoliv uzel - zjistim zda vsechny podobjekty jsou otevereny/zavreny
	isOpenSubChildren(id: number, isOpen: boolean) {

		if (this.isStoreNodeOpen(id,false) && isOpen == true) {
			return false;
		}

		 return this.existNodeOpen(id, isOpen) > 0;
	}	


	existNodeOpen(id: number, open: boolean): number {
		let result: number = 0;		
		for (var data of store.state.nazev.filter(c => c.parentId == id)) {

			if (data.isOpen == open && this.isFolderNode(data.id)) {					
					result++;						
				}
			result += this.existNodeOpen(data.id, open);		
		}		
		return result;
	}	

	isFolderNode(id: number) {
		return store.state.nazev.filter(c => c.parentId == id).length > 0;
	}

	openAllRoot(openClose: boolean) {			
		let id  = this.item.id == undefined ? -1 : this.item.id;
		this.openAll(id,openClose);			
	}

	openAllSubItems(open: boolean) {
		this.isOpen = open;
		let id  = this.item.id == undefined ? -1 : this.item.id;
		this.openAll(id, open);			
	}

	openAll(id: number, open: boolean) {
		for (var data of store.state.nazev.filter(c => c.parentId == id)) {				
			if (data.root == undefined) {				
				data.isOpen = open;
			}
			this.openAll(data.id, open);
		}
		return true;
	}	

	isStoreNodeOpen(id: number,isOpen:boolean) :boolean{
		let existuje = store.state.nazev.find(c => c.id == id);
		if (existuje != undefined) {
			return existuje.isOpen == isOpen;
		}
		return false;
	}

	///editacni rezim, když je true dvojklik nerozdela podsložky, ale zobrazi details
	isEditMode() {	
		return this.typeView == "edit";
	}

	editNode(id: number) {
		this.$router.push({ name: this.getRoute(this.detailRoute), params: { id: id.toString(), type: "update", returnRoute: this.getRoute(this.returnRoute)  } });
	}

	showNode(id: number) {
		this.$router.push({ name: this.getRoute(this.detailRoute), params: { id: id.toString(), type: "detail", returnRoute: this.getRoute(this.returnRoute) } });
	}

	//zobrazeni editacniho tlacitka
	showDetailButton() {
		return this.detailRoute != "";
	}

	//deleteNode() {
	//	this.$emit('remove-item', this.item);
	//}

	isOpen2: boolean = false;
	get isOpen() {			
		let existuje = store.state.nazev.find(c => c.id == this.item.id);			
		if (existuje != undefined) {
			this.isOpen2 = existuje.isOpen ;
		}
		return this.isOpen2 == undefined ? false : this.isOpen2;
	}
	set isOpen(value: boolean) {
		
		let existuje = store.state.nazev.find(c => c.id == this.item.id);
		if (existuje != undefined) {			
			existuje.isOpen = value;		
		}
		this.isOpen2 = value;
	}


	//test kontextoveho menu
	editItemContextMenu(target: any, cm: any) {
	}

	//test kontextoveho menu
	testContextMenu(target: any, cm: any) {
		//this.$store.dispatch("contextmenu/DEACTIVATE_CONTEXTMENU");
	}



	isFolder() {		
		return this.item.children != undefined && this.item.children.length != 0;
	}

	isExistSubFolder() {
		let result: boolean = false;
		if (this.item.children != undefined) {
			for (var i = 0; i < this.item.children.length; i++) {
				if (this.item.children[i].children != undefined) {
					return true;
				}
			}
		}
		return result;
	}

	toggle() {
		if (this.isFolder()) {
			this.isOpen = !this.isOpen;
		}
	}

	
	getRoute(route: any) {
		return route ? route : "";
	}

	//přidání nového prvku
	addItem(item: any) {
		let idGroup = item.id != undefined ? item.id : 0;
		this.$router.push({ name: this.getRoute(this.detailRoute), params: { idGroup: idGroup, type: "new", returnRoute: this.getRoute(this.returnRoute) } });
	}

	deleteItem() {		
		if (this.item.id != undefined) {
			this.$router.push({ name: this.getRoute(this.detailRoute), params: { id: this.item.id, type: "delete", returnRoute: this.getRoute(this.returnRoute) } });
		}
	};

	makeFolder() {
		if (!this.isFolder) {

			this.$emit('make-folder', this.item)
			this.isOpen = true
		}
	}

	data() {
		return {
			collapseAll: false
			//isOpen: false
		}
	}



	//načtení stylu
	get inputClass() {
		return {
			"bold": false,
			"label-design-head": false,
			"tree-item": true
		};
	}



}
